import { BaseEntity, BaseSearchForm } from 'entities'
import { TrainingLedger } from './training_ledger'

export type TrainingContent = BaseEntity & {
    id?: number
    trainingLedgerMasterId?: number
    date?: string
    content?: string
    grade?: Grade
    memo?: string
    recordType?: RecordType
    indexInRecordType?: number
    trainingLedgerMaster?: TrainingLedger
}

export type TrainingContentForm = TrainingContent

export type TrainingContentSearchForm = TrainingContent & BaseSearchForm

const RECORD_TYPE = ['accessment', 'training']
export type RecordType = typeof RECORD_TYPE[number]
export const RECORD_TYPE_JP = ['技能評価', '教育']
export const TRAINING_NAME_SELECT_ITEMS = RECORD_TYPE.map((value, index) => {
    return { label: RECORD_TYPE_JP[index], value: value }
})

const GRADE = ['合格', '不合格']
export type Grade = typeof GRADE[number]
export const GRADE_ITEMS = GRADE.map((value, index) => {
    return { label: GRADE[index], value: value }
})
